export const INPUT_TYPE_TEXT = 'text'
export const INPUT_TYPE_SEARCH = 'search'

export const TAG_PROVIDER = 'tag'

export const CACHE_PUT = 'put'
export const CACHE_REFRESH = 'refresh'

export const API_PREFIX_SIDEBAR = '/api/sidebar'
export const API_PREFIX_SIDEBAR_PROVIDER = '/api/sidebar/provider'
export const API_PREFIX_SIDEBAR_CACHEABLE = '/api/sidebar/cacheable'